import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=2d91814f&scoped=true"
import script from "./ModalRoot.vue?vue&type=script&lang=js"
export * from "./ModalRoot.vue?vue&type=script&lang=js"
import style0 from "./Modal.scss?vue&type=style&index=0&id=2d91814f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d91814f",
  null
  
)

export default component.exports